import React from "react";
import Hero from "../../components/medical/Hero";
import { ArrowUpRight } from "lucide-react";

import quantumCoverStoryImage from "../../assets/Images/quantum-cover-story.png";
import quantumArticleImage from "../../assets/Images/quantum-article.png";
import authorImage from "../../assets/Images/author.jpg";
const MAGAZINES = [
  {
    id: "coverstory",
    title: "Coverstory im Quantum Wirtschaftsmagazin",
    subtitle: "Quantum Asset Noir",
    description: "Lesen Sie die vollständige Coverstory im Quantum Wirtschaftsmagazin - exklusive Einblicke zu Executive Search und Asset Management.",
    url: "https://www.yumpu.com/de/document/read/70783724/quantum-asset-noir",
    image: quantumCoverStoryImage,
    imageAlt: "Quantum Wirtschaftsmagazin Cover",
  },
  {
    id: "article",
    title: "Top-Kandidaten folgen Top-Headhuntern",
    subtitle: "Einzelartikel im Quantum Magazin",
    description: "Claudia von Tein im Gespräch über zielgerichtete Direktansprache und die Rekrutierung von Führungskräften.",
    url: "https://quantum-magazin.com/claudia-von-tein-top-kandidaten-folgen-top-headhuntern/",
    image: quantumArticleImage,
    imageAlt: "Quantum Magazin Artikel",
  },
  {
    id: "author",
    title: "Autorenseite Claudia von Tein",
    subtitle: "Quantum Magazin",
    description: "Alle Beiträge und Artikel von Claudia von Tein im Quantum Magazin - Expertise zu Executive Search und Personalberatung.",
    url: "https://quantum-magazin.com/author/claudia-von-tein/",
    image: authorImage,
    imageAlt: "Claudia von Tein - Autorin Quantum",
  },
];

export default function MagazinesPage() {
  return (
    <>
      <Hero
        title="Presse & Magazine"
        subheading="REPEXO in den Medien - Artikel und Beiträge im Quantum Wirtschaftsmagazin."
      />
      <section className="bg-white py-12 md:py-16">
        <div className="container-app">
          <p className="text-center text-sm font-semibold uppercase tracking-[0.18em] text-gray-500">
            Quantum Wirtschaftsmagazin
          </p>
          <h2 className="mt-3 text-center text-xl font-semibold text-gray-900 sm:text-3xl md:text-4xl">
            Unsere Beiträge im Überblick
          </h2>

          <div className="mt-12 grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
            {MAGAZINES.map((item) => (
              <a
                key={item.id}
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex flex-col overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-[0_4px_20px_rgba(0,0,0,0.06)] transition-all duration-300 ease-out hover:shadow-[0_20px_50px_rgba(0,0,0,0.12)] hover:border-gray-300 hover:-translate-y-1"
              >
                {/* Magazine image - prominent, clear visibility */}
                <div className="relative aspect-[3/4] w-full overflow-hidden bg-gray-100">
                  <img
                    src={item.image}
                    alt={item.imageAlt}
                    className="h-full w-full object-cover transition-transform duration-500 ease-out group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
                  <span className="absolute bottom-3 right-3 flex h-10 w-10 items-center justify-center rounded-full bg-white/95 text-gray-900 shadow-lg opacity-0 transition-all duration-300 group-hover:opacity-100 group-hover:scale-110">
                    <ArrowUpRight className="h-5 w-5" strokeWidth={2} />
                  </span>
                </div>

                <div className="flex flex-1 flex-col p-6">
                  <span className="text-xs font-semibold uppercase tracking-[0.14em] text-gray-500">
                    {item.subtitle}
                  </span>
                  <h3 className="mt-2 text-lg font-semibold leading-snug text-gray-900 transition-colors duration-200 group-hover:text-gray-700">
                    {item.title}
                  </h3>
                  <p className="mt-3 flex-1 text-sm leading-relaxed text-gray-600">
                    {item.description}
                  </p>
                  <span className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-gray-900 group-hover:underline">
                    Zum Artikel
                    <ArrowUpRight className="h-4 w-4 shrink-0 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                  </span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

